// Styles
import '../scss/main.scss';

// Scripts
import { offer } from '@shop/frontend/dist/mobile/index';
import '/vendor/js/slick.js';

jQuery(function () {
  offer.getState(function (data) {
    const cmp = data.query.cmp;
    if (cmp === 'false') {
      $('body').addClass('clear');
      $('.cmp-hide').hide();
    }
  });

  /*accordion*/
  var content = $('.accordion-content');
  content.hide();
  $('.active .accordion-content').slideDown();
  $('.accordion-row').click(function () {
    if ($(this).hasClass('active')) {
      $(this).removeClass('active').find(content).slideUp();
    } else {
      content.slideUp();
      $('.accordion-row.active').removeClass('active');
      $(this).addClass('active').find(content).slideDown();
    }
  });
  /*accordion end*/

  /*carousel*/
  $('.slick').slick({
    arrows: false,
    autoplay: true,
    autoplaySpeed: 4000,
    slidesToShow: 2,
    slidesToScroll: 1,
    dots: true,
    mobileFirst: true,
  });

  $('.slick-2').slick({
    arrows: false,
    autoplay: true,
    autoplaySpeed: 4000,
    slidesToShow: 2,
    slidesToScroll: 1,
    dots: true,
    responsive: [
      {
        breakpoint: 768,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
        },
      },
    ],
  });
  /*carousel end*/

  var months = [
    'January',
    'February',
    'March',
    'April',
    'May',
    'June',
    'July',
    'August',
    'September',
    'October',
    'November',
    'December',
  ];

  function getRandom(min, max) {
    return Math.floor(Math.random() * (max - min) + min);
  }

  function getReviewDate() {
    $('.results-date').each(function () {
      var currentDate = new Date();
      var randomDays = getRandom(30, 60);

      currentDate.setDate(currentDate.getDate() - randomDays);

      var month = currentDate.getMonth();
      var day = currentDate.getDate();
      var year = currentDate.getFullYear();

      if (day < 10) {
        day = '0' + day;
      }

      var reviewDateString = months[month] + ' ' + day + ', ' + year;

      $(this).html(reviewDateString);
    });
  }

  getReviewDate();
});
